<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>审核</BreadcrumbItem>
          <BreadcrumbItem>动态审核</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">动态审核列表</div>
        <Input search placeholder="请输入关键字" v-model="search" @on-search="init" style="width:230px;margin-top:20px;" />
      </div>
    </div>

    <div class="my-item">
      <div class="news-change" style="margin-bottom:20px;">
        <RadioGroup v-model="newsAudit" type="button" @on-change="init">
          <Radio label="0">待审核</Radio>
          <Radio label="-2">已审核</Radio>
        </RadioGroup>
      </div>
      <template v-if="newsList && newsList.length">
        <Row :gutter="30">
          <Col style="width:20%;float:left" v-for="(item, index) in newsList" :key="index">
          <div class="my-item-box">
            <div class="mi-top" style="cursor:pointer;" @click="showAuditInfo(item)">
              <span class="mi-top-audit" v-if="item.auditSatus===1">审核通过</span>
              <span class="mi-top-audit" style="color:#b10042;" v-if="item.auditSatus===-1">审核不通过</span>
              <img :src="item.coverUrl" v-if="item.coverUrl" />
              <img src="@assets/img/empty.png" v-else />
            </div>
            <div class="mi-title f-tac" :title="item.title">{{item.title}}</div>
            <div class="mi-tool" v-if="item.auditSatus === 0">
              <div class="mi-tool-item z-primary" @click="pass(item)">审核通过</div>
              <div class="mi-tool-line">|</div>
              <div class="mi-tool-item" @click="unPass(item)">审核不通过</div>
            </div>
            <div class="mi-tool" v-if="item.auditSatus === 1">
              <div class="mi-tool-item z-primary" v-if="item.isShow" @click="setIsShow(item,false)">隐藏</div>
              <div class="mi-tool-item z-primary" v-else @click="setIsShow(item,true)">显示</div>
              <div class="mi-tool-line">|</div>
              <div class="mi-tool-item delBox">
                <Poptip confirm placement="top" title="确认删除此动态吗 ?" @on-ok="delItem(item)" style="width：100%;">
                  <div style="color:red;">删除</div>
                </Poptip>
              </div>
            </div>
          </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <iModal v-model="AuditInfoShow" title="动态信息" width="600px;">
      <div class="info-content-editor">
        <Form ref="formInline" :label-width="130" :model="formInline">
          <FormItem label="资讯封面：">
            <img v-if="formInline.coverUrl" :src="formInline.coverUrl" />
          </FormItem>
          <FormItem label="资讯标题：">
            <Input v-model="formInline.title" disabled />
          </FormItem>
          <FormItem label="公司名称：">
            <Input v-model="formInline.compName" disabled />
          </FormItem>
          <FormItem label="资讯概要：">
            <Input type="textarea" :rows="4" v-model="formInline.summary" disabled />
          </FormItem>
          <FormItem label="资讯内容：">
            <div v-html="formInline.content"></div>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" style="display:flex;justify-content:space-around;padding:0 50px;">
        <Button type="primary" @click="pass2()" v-if="formInline.auditSatus === 0">审核通过</Button>
        <Button v-if="formInline.auditSatus === 0" @click="unShow = true;">审核不通过</Button>
      </div>
    </iModal>

    <iModal v-model="unShow" title="审核不通过" width="600px;" @on-cancel="close">
      <div class="info-content-editor">
        <Form ref="formInline2" :label-width="130" :model="formInline2" :rules="ruleInline2">
          <FormItem label="驳回原因：" prop="remark">
            <Input type="textarea" :rows="4" v-model="formInline2.remark" placeholder="请输入驳回原因" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="unPassLast('formInline2')">确定</Button>
        <Button @click="close()">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "host-audit-list",
  data() {
    return {
      search: "",
      newsList: [],
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      newsAudit: "0",
      AuditInfoShow: false,
      formInline: {
        title: "",
        summary: "",
        coverUrl: "",
        content: "",
        auditSatus: 0,
      },
      newId: "",
      unNewId: "",
      unShow: false,
      formInline2: {
        remark: "",
      },
      ruleInline2: {
        remark: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "hostSetModule/getHostExhibition",
    }),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getNews: "hostAuditModule/getNews",
      auditNews: "hostAuditModule/auditNews",
      setNews: "hostAuditModule/setNews",
      delExNews: "hostAuditModule/delExNews",
    }),
    async init() {
      let list = await this.getNews({
        show: this.newsAudit,
        value: {
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 0,
              Predicates: [
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "title",
                    Value: "%" + this.search + "%",
                  },
                },
              ],
            },
          },
        },
      });
      this.newsList = list.items;
      this.pageSize = list.pageSize;
      this.pageIndex = list.pageIndex;
      this.totalCount = list.totalCount;
    },
    showAuditInfo(e) {
      this.AuditInfoShow = true;
      this.formInline.title = e.title;
      this.formInline.summary = e.summary;
      this.formInline.coverUrl = e.coverUrl;
      this.formInline.compName = e.compName;
      this.formInline.content = JSON.parse(e.introduction);
      this.formInline.auditSatus = e.auditSatus;
      this.newId = e.id;
      this.unNewId = e.id;
    },
    async pass(e) {
      let bool = await this.auditNews({
        Id: e.id,
        Show: 1,
      });
      if (bool && bool.successed) {
        this.$Message.success("操作成功！");
        this.init();
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    async pass2() {
      let bool = await this.auditNews({
        Id: this.newId,
        Show: 1,
      });
      if (bool && bool.successed) {
        this.$Message.success("操作成功！");
        this.AuditInfoShow = false;
        this.init();
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    unPass(e) {
      this.unShow = true;
      this.unNewId = e.id;
    },
    close() {
      this.AuditInfoShow = false;
      this.unShow = false;
      this.formInline2.remark = "";
    },
    async unPassLast(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        id: this.unNewId,
        show: -1,
        remark: this.formInline2.remark,
      };
      let bool = await this.auditNews(req);
      if (bool && bool.successed) {
        this.$Message.success("操作成功！");
        this.close();
        this.init();
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async delItem(e) {
      let result = await this.delExNews(e.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async setIsShow(item, e) {
      let bool = await this.setNews({
        id: item.id,
        isShow: e,
      });
      if (bool.successed) {
        this.init();
        this.$Message.success("操作成功！");
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.mi-top-audit {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #ccc;
  color: #000;
  z-index: 100;
  padding: 2px 10px;
  font-size: 14px;
}
.my-page {
  text-align: center;
}
.info-content-editor {
  padding-right: 50px;
  img {
    width: 260px;
    height: 170px;
  }
}
/deep/ .info-content-editor {
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }
  /* blockquote 样式 */
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  /* code 样式 */
  code {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  pre code {
    display: block;
  }

  /* ul ol 样式 */
  ul,
  ol {
    margin: 10px 0 10px 20px;
  }
}

.delBox {
  .ivu-poptip {
    width: 100%;
    /deep/ .ivu-poptip-rel {
      width: 100%;
    }
  }
}
</style>

